import { useNavigation } from "@react-navigation/native";
import { useCallback } from "react";
import { Pressable } from "react-native";

import { Button, Col, Row, TextBody, TextLabel } from "../lib";
import { Booking, formatDate, getBookingStatus } from "../services";
import { createStyles } from "../theme";

type Props = {
  booking: Booking;
  onShow?: (id: number) => void;
};

export function BookingItemArchived({ booking, onShow }: Props) {
  // Vars
  const navigation = useNavigation();
  const isActive = booking.completed && !booking.review;

  let description = formatDate(new Date(booking.date));

  if (booking.location.name) {
    description += ` - ${booking.location.name}`;
  }

  const isCreatable = !!booking.reviewable && !booking.review;
  const isUpdatable = !!booking.review?.editable;

  // Handlers
  const handlePress = useCallback(() => {
    onShow?.(booking.id);
  }, [booking.id, onShow]);

  const handleReview = useCallback(() => {
    navigation.navigate("BookingReview", { id: booking.id });
  }, [navigation, booking.id]);

  // Render
  return (
    <Pressable onPress={handlePress}>
      <Row.LR
        m="4"
        p="4"
        style={[$.container, (isActive || isCreatable) && $.active]}
      >
        <Col style={$.content}>
          <TextBody em>{booking.customer_name}</TextBody>
          <TextLabel mt="2" style={$.description}>
            {description}
          </TextLabel>
        </Col>
        {isCreatable && (
          <Button compact onPress={handleReview}>
            Rate
          </Button>
        )}
        {isUpdatable && (
          <Button compact onPress={handleReview}>
            Edit
          </Button>
        )}
        {!isCreatable && !isUpdatable && (
          <TextLabel>{getBookingStatus(booking)}</TextLabel>
        )}
      </Row.LR>
    </Pressable>
  );
}

const $ = createStyles({
  container: {
    backgroundColor: "surface",
    borderRadius: "4",
    mb: "4",
  },
  content: {
    flex: 1,
    minWidth: 0,
  },
  description: {
    flexShrink: 1,
  },
  active: {
    backgroundColor: "primaryActive",
  },
});
